export default "__VITE_PUBLIC_ASSET__fd3f9bf9__"